import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../index.css";
import moment from "moment";

//primereact
import { FileUpload } from "primereact/fileupload"

//helpers
import { Button, DropDownField } from "../../../helpers";

//common
import Loading from "../../../common/Loading";

//services
import { uploadFile } from "../../../services/api/company";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

const PoRescheduleReasonModel = (props) => {
    const {handleScheduledClick, buyerPO, initialPOSchedule, datewisePOSchedule, setIsSelectReasonModelVisible} = props
    const dispatch = useDispatch()

    const [selectedReason, setSelectedReason] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [docProof, setDocProof] = useState(null)

    let poRescheduleReasons = useSelector(state => state.common.poRescheduleReasonList)
    poRescheduleReasons = poRescheduleReasons.filter(eachReason => eachReason.statusId === 1)

    const handleSelectReasonChange = (e) => {
        setSelectedReason(e.target.value)
    }

    let isPunchedBatchRescheduled = false
    if(buyerPO.isRecurringPO){
        initialPOSchedule.forEach(eachInitialSchedule => {
            if (eachInitialSchedule.isSchedulePunched) {
                const relatedDateWiseSchedule = datewisePOSchedule.find(eachDatewiseSchedule => eachDatewiseSchedule.columnId === eachInitialSchedule.columnId)
                const formattedScheduleDate = moment(relatedDateWiseSchedule.scheduledDate).format('YYYY-MM-DD')
                if (relatedDateWiseSchedule && formattedScheduleDate !== eachInitialSchedule.scheduledDate) {
                    isPunchedBatchRescheduled = true
                }
            }
        })
    }

    const isRescheduleDocProofMandatory = !buyerPO.isRecurringPO || isPunchedBatchRescheduled

    const handleSubmitReason = () => {
        if (selectedReason) {
            if (isRescheduleDocProofMandatory && !docProof) {
                dispatch(raiseToast({ severity: 'warn', detail: "Please upload document.", life: 3000 }))
                return
            }
            buyerPO["poRescheduleReasonId"] = selectedReason
            setIsSelectReasonModelVisible(false)
            handleScheduledClick(buyerPO, docProof)
        } else {
            dispatch(raiseToast({ severity: 'warn', detail: "Please select reason.", life: 3000 }))
        }
    }

    const fileUploadHandler = ({ files, options }, doc_name) => {
        const [file] = files
        const fileReader = new FileReader()
        if (file.size > 5242880) {
            options.clear()
            return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: 'File size exceeds 5MB', life: 3000 }))
        }
        fileReader.onload = (e) => {
            uploadRescheduleDoc(doc_name, file.name, e.target.result, options.props.name)
        }
        fileReader.readAsDataURL(file)
        options.clear()
    }

    const uploadRescheduleDoc = async (doc_name, file_name, data_uri) => {
        let data = {
            doc_name,
            file_name,
            data_uri
        }
        setIsLoading(true)
        let response = await uploadFile(data)
        setIsLoading(false)
        if (!response.failure) {
            setDocProof(response.data)
            dispatch(raiseToast({ severity: 'success', detail: 'File uploaded successfully', life: 3000 }))
        } else {
            dispatch(raiseToast({ severity: 'error', detail: 'Error uploading file', life: 3000 }))
        }
    }

    const handleRemoveDocument = () => {
        setDocProof(null)
        dispatch(raiseToast({ severity: 'success', summary: "Document Removed", detail: 'The document has been removed successfully.', life: 3000 }))
    }

    return (
        <div className="flex flex-column pb-2 mb-2">
            <Loading visible={isLoading} />
            <DropDownField
                labelText="Select reason"
                value={selectedReason}
                options={poRescheduleReasons}
                optionLabel="poRescheduleReason"
                optionValue="poRescheduleReasonId"
                onChange={handleSelectReasonChange}
                required
            />
            <div className="mt-5 flex flex-row">
                {isRescheduleDocProofMandatory && (
                    <FileUpload
                        mode="basic"
                        name="inVoice"
                        accept="image/pdf/*"
                        customUpload
                        uploadHandler={(files) => fileUploadHandler(files, "RESCHEDULE_DOCPFROOF")}
                        auto
                        chooseLabel="Upload Doc"
                    />
                )
                }
                {docProof && (
                    <>
                        <a href={docProof} target="_blank" rel="noopener noreferrer" className="mx-2">
                            View
                        </a>
                        <span
                            onClick={handleRemoveDocument}
                            style={{ color: 'red', cursor: 'pointer', fontWeight: 'bold' }}
                        >
                            ×
                        </span>
                    </>
                )}
            </div>
            <div className="flex flex-row justify-content-end mt-5">
                <Button className="mt-5" label="Submit" onClick={handleSubmitReason} />
            </div>
        </div>
    )
}

export default PoRescheduleReasonModel
